// eslint-disable-next-line no-unused-vars
import React, { useContext, useEffect } from "react";
import { Route, Routes, ScrollToTop } from "@thd-olt-component-react/router";
import { AppContext } from "@thd-nucleus/app-render";
import PropTypes from "prop-types";
import { getRoutes } from "./routes";
import "./styles/app.scss";
import { triggerPageLoad } from "./utils/analytics";
import newrelic from "./utils/newrelic";
import type { AppProps } from "./types";

export function App({ recaptchaV3Key, serverPages }: AppProps) {
  useEffect(() => {
    document.title = "The Home Depot";
    triggerPageLoad();
    newrelic.setQuantumMetric();
  }, []);

  const { instance } = useContext(AppContext);
  const { currentRouteName, currentRouteComponent } = instance.router;
  const routes = getRoutes(currentRouteName, currentRouteComponent, serverPages);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route
          exact
          path={routes.home.path}
          element={<routes.home.component recaptchaV3Key={recaptchaV3Key} />}
        />
        <Route path="/error" />
      </Routes>
    </>
  );
}

App.propTypes = {
  recaptchaV3Key: PropTypes.string,
};

App.defaultProps = {
  recaptchaV3Key: "",
};
